import { useFormikContext } from 'formik';
import { FC } from 'react';
import { Switch } from '@mui/material';
import _ from 'lodash';
import { QcsFormControlLabel } from '../basic/QcsFormControlLabel';
import { SaveError } from '../SaveError';

interface Props {
  className?: string;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
}

export const QcsSwitch: FC<Props> = ({
  className,
  name,
  label,
  disabled,
  onChange,
}) => {
  const { values, errors, setFieldValue } = useFormikContext<any>();
  const value = !!_.get(values, name);
  const errorText = _.get(errors, name) as string;

  return (
    <>
      <SaveError error={errorText} />
      <QcsFormControlLabel
        control={
          <Switch
            className={className}
            id={name}
            name={name}
            checked={value}
            onChange={(_, checked) => {
              setFieldValue(name, checked);
              if (onChange) {
                onChange(checked);
              }
            }}
            disabled={disabled}
          />
        }
        label={label}
      />
    </>
  );
};
